import React from 'react'
import InputFill from '../form/InputFill'
import HeadingForm from '../elements/HeadingForm'
import Button from '../elements/Button'
import Textarea from '../form/Textarea'

import { useTranslation } from 'react-i18next'

const Register = ({
    handleSubmit,
    form,
    handleInputChange,
    clearErrorField,
    errors,
    isUpdate,
}) => {
    const { t } = useTranslation()

    const fields = [
        {
            label: 'customerInfo.username',
            name: 'userUsername',
            props: {
                disabled: isUpdate,
                required: true,
                i18nDataError: {
                    minLength: 6,
                },
            },
        },
        {
            label: 'customerInfo.password',
            name: 'userPassword',
            props: {
                type: 'password',
                required: true,
                i18nDataError: {
                    minLength: 6,
                },
            },
        },
        !isUpdate && {
            label: 'customerInfo.confirmPassword',
            name: 'confirmPassword',
            props: {
                type: 'password',
                required: true,
                i18nDataError: {
                    minLength: 6,
                },
            },
        },
        {
            label: t('customerInfo.contactInfo'),
            labelOnly: true,
        },
        {
            label: 'customerInfo.firstName',
            name: 'userName',
            props: {
                required: true,
            },
        },
        {
            label: 'customerInfo.phone',
            name: 'userPhone',
            props: {
                required: true,
                numberOnly: true,
            },
        },
        {
            label: 'customerInfo.email',
            name: 'userEmail',
            props: {
                required: true,
            },
        },
        {
            label: 'customerInfo.office',
            name: 'userOfficeName',
            props: {
                // required: true,
            },
        },
        // {
        //     label: t('customerInfo.address'),
        //     labelOnly: true,
        // },
        // {
        //     label: 'customerInfo.street',
        //     name: 'userStreet',
        //     props: {
        //         required: true,
        //     },
        // },
        // {
        //     label: 'customerInfo.apartmentNumber',
        //     name: 'userAddressNumber',
        //     props: {
        //         required: true,
        //     },
        // },
        // {
        //     label: 'customerInfo.postCode',
        //     name: 'userPostcode',
        //     props: {
        //         required: true,
        //     },
        // },
        // {
        //     label: 'customerInfo.city',
        //     name: 'userCity',
        //     props: {
        //         required: true,
        //     },
        // },
        // {
        //     label: 'customerInfo.floor',
        //     name: 'floor',
        //     props: {
        //         // required: true,
        //     },
        // },
        // {
        //     label: 'customerInfo.address',
        //     name: 'userAddressNote',
        //     component: Textarea,
        // },
    ]

    return (
        <form className="container register py-4" onSubmit={handleSubmit}>
            <HeadingForm>
                {t(
                    isUpdate
                        ? 'personalInfo.titleUpdate'
                        : 'personalInfo.titleRegister'
                )}
            </HeadingForm>

            <div className="row">
                {fields.filter(Boolean).map((field, index) => {
                    const Component = field.component || InputFill

                    if (field.labelOnly) {
                        return (
                            <div key={index} className="col-12 mt-6 heading-5">
                                <div className="label-only">{field.label}</div>
                            </div>
                        )
                    }

                    return (
                        <div key={index} className="col-12 col-md-6">
                            <Component
                                className="mt-6"
                                label={t(field.label)}
                                name={field.name}
                                value={form[field.name]}
                                error={errors[field.name]}
                                onChange={handleInputChange}
                                onFocus={() => clearErrorField(field.name)}
                                {...field.props}
                            />
                        </div>
                    )
                })}
            </div>

            <div className="mt-8 text-center">
                <Button fullWidth>
                    {t(isUpdate ? 'button.update' : 'button.register')}
                </Button>
            </div>
        </form>
    )
}

export default Register
